<style lang="scss" src="./component.scss"></style>

<template>
  <div
    class="knowledge-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <span class="knowledge-skeleton__sr">{{
      $t("Загрузка данных клиента…")
    }}</span>
    <div aria-hidden="true">
      <div class="knowledge-skeleton__intro">
        <div class="knowledge-skeleton__shine knowledge-skeleton__label"></div>
        <div
          v-for="line in 3"
          :key="line"
          class="knowledge-skeleton__shine knowledge-skeleton__line"
        ></div>
      </div>
      <div class="knowledge-skeleton__identity">
        <div v-for="field in 3" :key="field">
          <div
            class="knowledge-skeleton__shine knowledge-skeleton__label"
          ></div>
          <div
            class="knowledge-skeleton__shine knowledge-skeleton__input"
          ></div>
        </div>
      </div>
      <div class="knowledge-skeleton__questions">
        <div
          v-for="question in 12"
          :key="question"
          class="knowledge-skeleton__question"
        >
          <div class="knowledge-skeleton__heading">
            <div
              class="knowledge-skeleton__shine knowledge-skeleton__number"
            ></div>
            <div
              class="knowledge-skeleton__shine knowledge-skeleton__title"
            ></div>
          </div>
          <div
            class="knowledge-skeleton__options"
            :class="{ 'knowledge-skeleton__options--short': question < 3 }"
          >
            <div
              v-for="option in question < 3 ? 2 : 4"
              :key="option"
              class="knowledge-skeleton__shine knowledge-skeleton__option"
            ></div>
          </div>
        </div>
      </div>
      <div class="knowledge-skeleton__risks">
        <div class="knowledge-skeleton__shine knowledge-skeleton__label"></div>
        <div
          v-for="line in 8"
          :key="line"
          class="knowledge-skeleton__shine knowledge-skeleton__line"
        ></div>
        <div class="knowledge-skeleton__shine knowledge-skeleton__input"></div>
      </div>
    </div>
  </div>
</template>
